export default {
    MAIN_IMAGE_PLACEHOLDER: '/images/mocks/banner_grid_bransoletki.webp',
    HERO_IMAGE_RATIO: { base: 1, md: 1920 / 820 },
    BANNER_IMAGE_RATIO: { base: 1, md: 1920 / 740 }
}